import React, { useContext, useEffect, useMemo, useState } from 'react';

import FilteringTable from './Table/FilteringTable/FilteringTable';
import ColumnFilter from './Table/FilteringTable/ColumnFilter';
import PageTitle from '../layouts/PageTitle';

import { tableColumnNamesNomination } from '../../utils/tableColumnNamesNomination';
import { tableRowsValuesNomination } from '../../utils/tableRowsValuesNomination';
import { CommonCollections } from '../../App';
import { useStaticCollections } from '../../context/StaticCollections';
import NominationCell from './NominationCell';

import { filteringTableGetTableColumns } from '../../utils/filteringTableGetTableColumns';
import { filteringTableFilterUniqueCandidates } from '../../utils/filteringTableFilterUniqueCandidates';
import { useProposerCollections } from '../../context/ProposerCollections';
import { useLoggedInUserContextProvider } from '../../context/LoggedInUserContext';
import { useAdminActionCollections } from '../../context/AdminActionCollections';

const Nomination = () => {
  const { userDetails } = useLoggedInUserContextProvider();
  const {
    electionTypes,
    nonAdminNominationStatusTypes,
    sectionalCommitteesWithCmse,
    isLoading: staticLoading,
  } = useStaticCollections();
  const { enableNewSubmission } = useAdminActionCollections();

  const {
    candidates,
    userDraftNominationArray,
    userNominationArray,
    nominationStateArray,
    isLoading: proposerLoading,
  } = useProposerCollections();

  const { setNominationId } = useContext(CommonCollections);

  const updatedUserDraftNominationArray = useMemo(
    () =>
      userDraftNominationArray.map((item) => ({
        ...item,
        id: `${item.id}d`,
      })),
    [userDraftNominationArray],
  );

  const [nominationsData, setNominationsData] = useState([]);
  const [nominationsColumns, setNominationsColumns] = useState([]);
  const [urlString, setUrlString] = useState('');

  useEffect(() => {
    const tableColumns = filteringTableGetTableColumns(
      tableColumnNamesNomination,
      ColumnFilter,
      NominationCell,
    );

    const mergedData = [
      ...userNominationArray,
      ...updatedUserDraftNominationArray,
    ];

    const tableData = tableRowsValuesNomination(
      mergedData,
      electionTypes,
      nonAdminNominationStatusTypes,
      sectionalCommitteesWithCmse,
      nominationStateArray,
    );

    setNominationsColumns(tableColumns);

    const candidatesData = [
      tableData?.map((item) => item.candidateId),
      tableData,
    ];

    const tableDataTwo = Object.values(candidatesData[1]).map((candidate) => {
      if (candidates[candidate.candidateId] !== undefined) {
        candidate.candidate = candidates[candidate.candidateId];
      }

      return candidate;
    });

    const filteredData = filteringTableFilterUniqueCandidates(tableDataTwo);

    setNominationsData(filteredData);
    setNominationId(null);

    if (enableNewSubmission) {
      setUrlString('application');
    } else {
      setUrlString('');
    }
  }, [
    userDetails,
    electionTypes,
    nonAdminNominationStatusTypes,
    sectionalCommitteesWithCmse,

    candidates,
    userDraftNominationArray,
    updatedUserDraftNominationArray,
    userNominationArray,

    setNominationId,
    enableNewSubmission,
  ]);

  if (staticLoading || proposerLoading) {
    return (
      <>
        <PageTitle activeMenu="Nomination" motherMenu="Home" />
        <div className="card">
          <div className="card-body text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading nominations...</span>
            </div>
            <p className="mt-3 text-muted mb-0">Loading nominations...</p>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <PageTitle activeMenu="Nomination" motherMenu="Home" />
      <FilteringTable
        componentName="Nomination"
        columns={nominationsColumns}
        data={nominationsData}
        urlString={urlString}
        buttonText="New Nomination"
        isLoading={staticLoading || proposerLoading}
      />
    </>
  );
};

export default Nomination;
